import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, Link } from 'react-router-dom'
import { useLocalizedLink } from '../../hooks/useLocalizedLink'
import SEO from '../../components/SEO/SEO'
import { seoBreadcrumbPair, seoBreadcrumbTriple } from '../../utils/seoUtils'
import './Federations.css'

const federations = [
  {
    id: 'kubo',
    name: 'Федерация КУБО',
    nameEn: 'KUBO Federation',
    nameJa: 'КУБО連盟',
    subtitle: 'Classical Universal Wrestling',
    subtitleRu: 'Классическая Универсальная Борьба',
    subtitleJa: '古典的ユニバーサルレスリング',
    logo: '/images/federations/KUBO Federation.png',
    description: 'Федерация КУБО объединяет школы классической универсальной борьбы по всему миру. Федерация развивает и стандартизирует техники КУБО, проводит аттестации и соревнования.',
    descriptionEn: 'KUBO Federation unites schools of classical universal wrestling worldwide. The federation develops and standardizes KUBO techniques, conducts certifications and competitions.',
    descriptionJa: 'КУБО連盟は、世界中の古典的ユニバーサルレスリングの学校を結集しています。連盟はКУБОの技術を開発し標準化し、認定と競技会を実施しています。',
    history: 'Федерация КУБО была основана для объединения школ, практикующих классическую универсальную борьбу. Федерация способствует развитию и сохранению традиций этого боевого искусства.',
    historyEn: 'KUBO Federation was founded to unite schools practicing classical universal wrestling. The federation promotes the development and preservation of this martial art tradition.',
    historyJa: 'КУБО連盟は、古典的ユニバーサルレスリングを実践する学校を結集するために設立されました。連盟はこの武道の伝統の発展と保存を促進しています。',
    activities: ['Проведение аттестаций на пояса', 'Организация соревнований', 'Разработка стандартов техники', 'Обучение инструкторов', 'Международное сотрудничество'],
    activitiesEn: ['Belt certification exams', 'Competition organization', 'Technique standards development', 'Instructor training', 'International cooperation'],
    activitiesJa: ['帯認定試験の実施', '競技会の組織', '技術基準の開発', '指導者訓練', '国際協力']
  },
  {
    id: 'karatejutsu',
    name: 'Федерация Карате-дзюцу',
    nameEn: 'Karate-jutsu Federation',
    nameJa: '空手術連盟',
    logo: '/images/federations/Karate-jutsu Federation.png',
    description: 'Федерация карате-дзюцу развивает и продвигает традиционные техники карате. Федерация объединяет школы, практикующие различные стили карате-дзюцу.',
    descriptionEn: 'Karate-jutsu Federation develops and promotes traditional karate techniques. The federation unites schools practicing various karate-jutsu styles.',
    descriptionJa: '空手術連盟は、伝統的な空手技術を開発し促進しています。連盟は様々な空手術スタイルを実践する学校を結集しています。',
    history: 'Федерация карате-дзюцу была создана для сохранения и развития традиционных техник карате с акцентом на боевую эффективность. Объединяет различные школы и стили.',
    historyEn: 'Karate-jutsu Federation was created to preserve and develop traditional karate techniques with emphasis on combat effectiveness. Unites various schools and styles.',
    historyJa: '空手術連盟は、戦闘効果を重視して伝統的な空手技術を保存し発展させるために創設されました。様々な学校とスタイルを結集しています。',
    activities: ['Стандартизация техник карате-дзюцу', 'Проведение семинаров и мастер-классов', 'Организация соревнований по ката и кумитэ', 'Аттестация инструкторов', 'Разработка учебных программ'],
    activitiesEn: ['Standardization of karate-jutsu techniques', 'Seminars and master classes', 'Kata and kumite competitions', 'Instructor certification', 'Training program development'],
    activitiesJa: ['空手術技術の標準化', 'セミナーとマスタークラスの実施', '型と組手の競技会の組織', '指導者認定', '訓練プログラムの開発']
  },
  {
    id: 'jujutsu',
    name: 'Федерация Дзю-дзюцу',
    nameEn: 'Jujutsu Federation',
    nameJa: '柔術連盟',
    logo: '/images/federations/Jujutsu Federation.png',
    description: 'Федерация дзю-дзюцу объединяет практикующих традиционного японского дзю-дзюцу. Федерация способствует сохранению традиций и развитию техник различных школ дзю-дзюцу.',
    descriptionEn: 'Jujutsu Federation unites practitioners of traditional Japanese jujutsu. The federation promotes preservation of traditions and development of techniques from various jujutsu schools.',
    descriptionJa: '柔術連盟は、伝統的な日本の柔術の実践者を結集しています。連盟は様々な柔術学校の伝統の保存と技術の発展を促進しています。',
    history: 'Федерация дзю-дзюцу объединяет различные традиционные школы японского дзю-дзюцу, сохраняя их уникальные техники и методы обучения, при этом способствуя обмену знаниями.',
    historyEn: 'Jujutsu Federation unites various traditional schools of Japanese jujutsu, preserving their unique techniques and teaching methods while promoting knowledge exchange.',
    historyJa: '柔術連盟は、日本の柔術の様々な伝統的な学校を結集し、その独自の技術と教育方法を保存しながら、知識の交換を促進しています。',
    activities: ['Сохранение традиций различных школ', 'Проведение аттестаций', 'Организация семинаров по традиционным техникам', 'Развитие программ обучения', 'Международные обмены'],
    activitiesEn: ['Preservation of various school traditions', 'Certification exams', 'Seminars on traditional techniques', 'Training program development', 'International exchanges'],
    activitiesJa: ['様々な学校の伝統の保存', '認定試験の実施', '伝統的技術に関するセミナーの組織', '訓練プログラムの発展', '国際交流']
  },
  {
    id: 'aikibujutsu',
    name: 'Федерация Айки-бу-дзюцу',
    nameEn: 'Aiki-bu-jutsu Federation',
    nameJa: '合気武術連盟',
    logo: '/images/federations/Aiki-bu-jutsu Federation.png',
    description: 'Федерация айки-бу-дзюцу развивает комплексную систему айкидо с оружием. Федерация объединяет техники айкидо и традиционной работы с оружием.',
    descriptionEn: 'Aiki-bu-jutsu Federation develops a comprehensive system of aikido with weapons. The federation combines aikido techniques with traditional weapon work.',
    descriptionJa: '合気武術連盟は、武器を使用した合気道の包括的なシステムを開発しています。連盟は合気道の技術と伝統的な武器の使用を組み合わせています。',
    history: 'Федерация айки-бу-дзюцу была создана для развития комплексной системы, объединяющей техники айкидо и работы с различными видами оружия (дзё, боккэн, танто).',
    historyEn: 'Aiki-bu-jutsu Federation was created to develop a comprehensive system combining aikido techniques with work with various weapons (jo, bokken, tanto).',
    historyJa: '合気武術連盟は、合気道の技術と様々な武器（杖、木剣、短刀）の使用を組み合わせた包括的なシステムを開発するために創設されました。',
    activities: ['Развитие техник с оружием', 'Интеграция техник айкидо и оружия', 'Проведение семинаров', 'Аттестация на пояса', 'Организация демонстраций'],
    activitiesEn: ['Weapon technique development', 'Integration of aikido and weapon techniques', 'Seminars', 'Belt certification', 'Demonstration organization'],
    activitiesJa: ['武器技術の発展', '合気道と武器技術の統合', 'セミナーの実施', '帯認定', 'デモンストレーションの組織']
  }
]

function Federations() {
  const { t, i18n } = useTranslation()
  const getLocalizedLink = useLocalizedLink()
  const { federationId } = useParams()

  const displayedFederation = federationId 
    ? federations.find(f => f.id === federationId)
    : null

  const isRussian = i18n.language === 'ru'
  const isJapanese = i18n.language === 'ja'

  const listBreadcrumbs = useMemo(
    () => seoBreadcrumbPair(t('common.home'), t('common.federations'), 'federations'),
    [t]
  )
  const detailBreadcrumbs = useMemo(() => {
    if (!displayedFederation) return listBreadcrumbs
    const leaf = isJapanese
      ? displayedFederation.nameJa || displayedFederation.nameEn
      : isRussian
        ? displayedFederation.name
        : displayedFederation.nameEn
    return seoBreadcrumbTriple(
      t('common.home'),
      t('common.federations'),
      'federations',
      leaf,
      `federations/${displayedFederation.id}`
    )
  }, [displayedFederation, t, isJapanese, isRussian, listBreadcrumbs])

  if (displayedFederation) {
    return (
      <div className="federations-page">
        <SEO 
          title={isJapanese ? (displayedFederation.nameJa || displayedFederation.nameEn) : (isRussian ? displayedFederation.name : displayedFederation.nameEn)}
          breadcrumbItems={detailBreadcrumbs}
        />
        <div className="container">
          <Link to={getLocalizedLink('/federations')} className="back-link">← {t('federations.back', 'Back to Federations')}</Link>
          <div className="federation-detail">
            {displayedFederation.logo && (
              <div className="federation-logo-detail">
                <img 
                  src={displayedFederation.logo} 
                  alt={isJapanese ? (displayedFederation.nameJa || displayedFederation.nameEn) : (isRussian ? displayedFederation.name : displayedFederation.nameEn)}
                  className="federation-logo-image"
                  onError={(e) => {
                    e.target.style.display = 'none'
                  }}
                />
              </div>
            )}
            <h1>{isJapanese ? (displayedFederation.nameJa || displayedFederation.nameEn) : (isRussian ? displayedFederation.name : displayedFederation.nameEn)}</h1>
            {displayedFederation.subtitle && (
              <p className="federation-subtitle">{isJapanese ? (displayedFederation.subtitleJa || displayedFederation.subtitle) : (isRussian ? (displayedFederation.subtitleRu || displayedFederation.subtitle) : displayedFederation.subtitle)}</p>
            )}
            <p className="federation-description">
              {isJapanese ? (displayedFederation.descriptionJa || displayedFederation.descriptionEn) : (isRussian ? displayedFederation.description : displayedFederation.descriptionEn)}
            </p>

            {displayedFederation.history && (
              <section className="federation-section">
                <h2>{t('federations.history', 'History')}</h2>
                <p>{isJapanese ? (displayedFederation.historyJa || displayedFederation.historyEn) : (isRussian ? displayedFederation.history : displayedFederation.historyEn)}</p>
              </section>
            )}

            {displayedFederation.activities && displayedFederation.activities.length > 0 && (
              <section className="federation-section">
                <h2>{t('federations.activities', 'Activities')}</h2>
                <ul className="activities-list">
                  {displayedFederation.activities.map((activity, index) => (
                    <li key={index}>
                      {isJapanese 
                        ? (displayedFederation.activitiesJa && displayedFederation.activitiesJa[index] || displayedFederation.activitiesEn && displayedFederation.activitiesEn[index] || activity)
                        : (isRussian ? activity : (displayedFederation.activitiesEn && displayedFederation.activitiesEn[index] || activity))}
                    </li>
                  ))}
                </ul>
              </section>
            )}

            <div className="federation-actions">
              <Link to={getLocalizedLink('/schools')} className="btn btn-primary">
                {t('federations.schools', 'Member Schools')}
              </Link>
              <Link to={getLocalizedLink('/events')} className="btn btn-secondary">
                {t('common.events')}
              </Link>
              <Link to={getLocalizedLink('/certifications')} className="btn btn-secondary">
                {t('common.certifications')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="federations-page">
      <SEO 
        title={t('common.federations')}
        description={t('federations.description', 'Federations of SUMA International')}
        breadcrumbItems={listBreadcrumbs}
      />
      <div className="container">
        <div className="federations-header">
          <h1>{t('common.federations')}</h1>
          <p className="page-description">
            {t('federations.intro', 'SUMA International includes several specialized federations, each dedicated to specific martial arts disciplines.')}
          </p>
        </div>

        <div className="federations-grid">
          {federations.map(federation => (
            <Link 
              key={federation.id}
              to={`${getLocalizedLink('/federations')}/${federation.id}`}
              className="federation-card"
            >
              <div className="federation-header">
                <h3>{isJapanese ? (federation.nameJa || federation.nameEn) : (isRussian ? federation.name : federation.nameEn)}</h3>
                {federation.subtitle && (
                  <p className="federation-card-subtitle">{isJapanese ? (federation.subtitleJa || federation.subtitle) : (isRussian ? (federation.subtitleRu || federation.subtitle) : federation.subtitle)}</p>
                )}
              </div>
              <p className="federation-card-description">
                {isJapanese ? (federation.descriptionJa || federation.descriptionEn) : (isRussian ? federation.description : federation.descriptionEn)}
              </p>
              <span className="federation-link-text">
                {t('federations.learnMore', 'Learn more')} →
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Federations
